import { render, staticRenderFns } from "./SendQuery.vue?vue&type=template&id=7dcee965&scoped=true&"
import script from "./SendQuery.vue?vue&type=script&lang=js&"
export * from "./SendQuery.vue?vue&type=script&lang=js&"
import style0 from "./SendQuery.vue?vue&type=style&index=0&id=7dcee965&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcee965",
  null
  
)

export default component.exports